export default [
  {
    name: 'SystemTaskMonitoring',
    path: '/system_task',
    component: () =>
      import(
        /* webpackChunkName: "SystemTaskMonitoring" */ './SystemTaskMonitoring.vue'
      )
  },
  {
    name: 'PMT001',
    path: '/PMT001',
    component: () =>
      import(
        /* webpackChunkName: "SystemLog" */ '@/projects/teller/views/SystemLog/SystemLog.vue'
      )
  },
  {
    name: 'PMT002',
    path: '/PMT001/PMT002',
    component: () =>
      import(
        /* webpackChunkName: "SystemLog" */ '@/projects/teller/views/SystemLog/SystemLogDetail.vue'
      )
  }
]
